import { useQuery } from "@tanstack/react-query"
import { api, useRoleConf } from "../../hooks"
import { datarefQueryRoleconf } from "../datarefQuery.roleconf"
import { datarefToReferentialCode } from "../datarefToReferentialCode"
import { sectorDataRefApiRoleConf } from "./sectorDataref.roleconf"
import type { SectorsDatarefApi } from "./sectorDataref.type"

export const useGetSectorDataref = () => {
  const { endpoint, queryKey } = useRoleConf(sectorDataRefApiRoleConf())
  const queryOptions = useRoleConf(datarefQueryRoleconf())
  const { data: sectorDataref = [], isLoading: sectorDatarefIsLoading } = useQuery({
    queryKey,
    queryFn: () => api.get<SectorsDatarefApi>(endpoint),
    select: (raw) => raw.content ?? [],
    ...queryOptions,
  })

  const sectorReferential = datarefToReferentialCode(sectorDataref)

  return { sectorDataref, sectorDatarefIsLoading, sectorReferential }
}
